import React from 'react';
import { BiData } from '@wix/da-bi/pkg/events';
import { getRecipientForComment } from '../../../utils';
import { getCommentNotificationQueue } from '../../../../Comment/utils';
import { ResourceType } from '../../../../types/resource';
import CoreBadgeList from '../../CoreBadgeList';
var CommentCoreBadgeList = function (_a) {
    var _b;
    var comment = _a.comment, className = _a.className;
    return (React.createElement(CoreBadgeList, { className: className, badges: (_b = comment.awardedBadges) !== null && _b !== void 0 ? _b : [], recipient: getRecipientForComment(comment), notificationQueueName: getCommentNotificationQueue(comment), biData: BiData({
            evid: 323,
            sectionname: 'comments',
            typeid: ResourceType.COMMENT,
            itemid: comment.commentId,
        }), size: "small" }));
};
CommentCoreBadgeList.displayName = 'CommentCoreBadgeList';
export default CommentCoreBadgeList;
//# sourceMappingURL=CommentCoreBadgeList.js.map